import { useState, useEffect } from 'react';

export function useHydrationEnable() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return mounted;
}
